import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/issues`,
});

// 📖 Get All Issues (POST with filters)
export async function fetchIssues(payload = {}) {
  try {
    const res = await API.post("/list", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✏️ Update Issue Status / Priority / Notes
export async function updateIssue(id, payload) {
  try {
    const res = await API.put(`/${id}/status`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 💬 Reply to Issue
export async function replyIssue(issueId, payload) {
  try {
    const res = await API.post(`/${issueId}/reply`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🗑️ Delete Issue
export async function deleteIssue(id) {
  try {
    const res = await API.delete(`/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}